@if (questId==0) {
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  @if (questId==0) {
    <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
  }
  @if (questId==0) {
    <button mat-icon-button [mat-dialog-close]="true" style="float:right;background-color: transparent;z-index: 99; top:-20px; right: -20px;">
      <i class="pi pi-times" aria-hidden="true"></i>
    </button>
  }
  @if (questId==0) {
    <p-table #pt [value]="guestMasterProfiles" class="guestMasterProfilesTable" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="guestMasterProfileId" selectionMode="single"
      [(selection)]="guestMasterProfile" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
      [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
      currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
      sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}" [resizableColumns]="true" [autoLayout]="true" [responsive]="true">
      @if (questId==0) {
        <ng-template pTemplate="caption">
          <div class="d-block text-end justify-content-between align-items-center">
            <h1 style="float: left;margin: 6px;">GuestMasterProfiles</h1>
            <span>
              <!--clear filters-->
              @if (showFilter) {
                <button pButton pRipple class="p-button-text"
                  style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
                (click)="reloadPage()">Clear Filters</button>
              }
              <!--add new-->
              @if (!outlineNewButton) {
                <button pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
                (click)="onOpenFormAdd()">New GuestMasterProfile +</button>
              }
              @if (outlineNewButton) {
                <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
                (click)="onOpenFormAdd()">New GuestMasterProfile +</button>
              }
            </span>
          </div>
        </ng-template>
      }
      @if (questId==0) {
        <ng-template pTemplate="header">
          <tr>
            @for (col of columns; track col) {
              <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
                {{col.header}}
                <p-sortIcon [field]="col.field"></p-sortIcon>
              </th>
            }
            <th [ngStyle]="{'width': 'auto'}"></th>
          </tr>
          @if (showFilter) {
            <tr>
              <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'guestMasterProfileId', 'in')"></th>
              <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'firstName', 'in')"></th>
              <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'lastName', 'in')"></th>
              <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'emailAddress', 'in')"></th>
              <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'mobilePhone', 'in')"></th>
              <th [ngStyle]="{'width': 'auto'}"></th>
            </tr>
          }
        </ng-template>
      }
      @if (questId==0; as guestMasterProfile) {
        <ng-template pTemplate="body" let-guestMasterProfile>
          <tr [pSelectableRow]="guestMasterProfile">
            <td>{{guestMasterProfile.guestMasterProfileId}} </td>
            <td>{{guestMasterProfile.firstName}}</td>
            <td>{{guestMasterProfile.lastName}}</td>
            <td>{{guestMasterProfile.emailAddress}}</td>
            <td>{{guestMasterProfile.mobilePhone}}</td>
            <td><span style="float:none">
              <a>
                <i class="pi pi-pencil" aria-hidden="true"
                style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(guestMasterProfile)"></i>
              </a>
            </span>
          </td>
        </tr>
      </ng-template>
    }
  </p-table>
}
}